import React, { useState } from "react";
import FontAwesome from "react-fontawesome";
import Showimage from "./modalshowimage";
//import { toast } from 'react-toastify';

const RenderUser = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  handelDelete,
  search,
  onUpdate,
}) => {
  const [empData, setempData] = useState({
    empid: "",
    empname: "",
  });
  const [isOpen, setisOpen] = useState(false);

  const [showScroll, setShowScroll] = useState(false);

  const [imageUrl, setImageUrl] = useState("");
  const [isShowimage, setisShowimage] = useState(false);
  
  const handelClose = () => {
    setisShowimage(false);
  
  };

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      // console.log('over 400')
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
      // console.log('non 400')
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  window.addEventListener("scroll", checkScrollTop);

  const handleCancle = () => {
    setisOpen(false);
  };
  const handleClick = (imageUrl) => {
    setImageUrl(imageUrl)
    setisShowimage(true);
  };
  const onConfirm = () => {
    setisOpen(false);
    onUpdate();
  };
  //console.log(list);
  if (!list) return;

  return (
    <>
      <Showimage isOpen={isShowimage} onCancel={handelClose} list={imageUrl} />
   
    <div className="row course-list list m-1">
    
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div
                ref={lastBookElementRef}
                key={index}
                className="card text-dark p-0 mb-2 me-2  col-xs-12 col-sm-3"
              >
                <div className="container-fluid">
                  <span className="badge rounded-pill bg-secondary">
                    {item.no}
                  </span>

                  <div className="row no-gutters align-items-center justify-content-left">
                    <div className="col-auto text-center mb-2 p-1 text-center">
                    <img
                        src={item.ImageURL }
                         className="img-fluid"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title=""
                        alt=""
                       
                      ></img>
                    </div>

                    <div className="col-auto ms-2">
                      <div className="card-body p-1">
                        <div className="card-text">
                          <h6
                            className="card-title d-inline me-2"
                            style={{ fontSize: "14px" }}
                          >
                             {item.checktime} 
                          </h6>
                        </div>
                        {/* <div className="card-text">
                          <h6
                            className="card-text d-inline me-2"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              aria-hidden="true"
                              className="fa fa-briefcase"
                            />{" "}
                            {item.department}
                          </h6>
                          <h6
                            className="card-text d-inline"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              aria-hidden="true"
                              className="fa fa-building"
                            />{" "}
                            {item.company_code}
                          </h6>
                        </div> */}
                 
                 <button
                            className="btn btn-warning btn-sm m-1"
                            onClick={() =>
                              handleClick(item.ImageURL)
                            }
                          >
                            {" "}
                            <FontAwesome name="eye" />
                          </button>

                  
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
                key={index}
                className="card text-dark p-0 mb-2 me-2  col-xs-12 col-sm-3"
              >
                <div className="container-fluid">
                  <div className="d-flex justify-content-between mt-2">
                    <span className="badge rounded-pill bg-secondary">
                      {item.no}
                    </span>
                  </div>
                  <div className="row no-gutters align-items-center justify-content-left">
                    <div className="col-auto text-center mb-2 p-1 text-center">
                      <img
                        src={item.ImageURL }
                         className="img-fluid"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title=""
                        alt=""
                       
                      ></img>
                    </div>

                    <div className="col-auto ms-2">
                      <div className="card-body p-1">
                      <div className="card-text">
                          <h6
                            className="card-title d-inline me-2"
                            style={{ fontSize: "12px" }}
                          >
                            {item.checktime} 
                          </h6>
                        </div>
                    
                       
                        <button
                            className="btn btn-warning btn-sm m-1"
                            onClick={() =>
                              handleClick(item.ImageURL)
                            }
                          >
                            {" "}
                            <FontAwesome name="eye" />
                          </button>

                         
                       
                       
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}

    </div>
    </>
  );
};

export default RenderUser;
